import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <section className="chapter">
      <p className="chapter-paragraph">
        Such limitations in supply force doctors into difficult situations when deciding who is
        treated first, knowing that every patient runs the risk of having their disease progress as
        they wait. This potentially makes them too ill to receive the treatment when it finally
        becomes an option.
      </p>
      <p className="chapter-paragraph">
        According to Dr. Myo Htut, Associate Professor, Division of Multiple Myeloma, Department of
        Hematology and Hematopoietic Cell Transplantation at City of Hope in Los Angeles, “Extensive
        wait times for CAR T treatment may lead to suboptimal outcomes for those patients who are
        eligible and could benefit from this therapy. In patients who have very aggressive cancer,
        as is often the case in multiple myeloma that no longer responds to treatment, time is
        simply not on their side.”
      </p>
      <p className="chapter-paragraph">But now there is hope on the horizon.</p>
    </section>
  );
}

export default Chapter3;
